/**
 * was created by tigran at 13.10.23
 */
import {IProps} from "../types/homePageTypes";

import createGenericContext from './createGenericContext'

export const [useGlobalContext, GlobalContextProvider] =
    createGenericContext<IProps>('GlobalContext')